import { ViewFactory } from 'wdc-cube-react'
import ResultadoAnaliseVisaoCedenteScope from '../resultado_analise_visao_cedente.scopes'
import { ResultadoAnaliseVisaoCedenteView } from './resultado_analise.view'

export function registerViews(rv = ViewFactory.register) {
    rv(ResultadoAnaliseVisaoCedenteScope, ResultadoAnaliseVisaoCedenteView)
}
